var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.hooks.blockHelperMissing.call(depth0,container.lambda((depth0 != null ? lookupProperty(depth0,"PackPrices") : depth0), depth0),{"name":"PackPrices","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":10,"column":15}}})) != null ? stack1 : "");
},"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, alias3=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"pack-prices\" data-usertype=\""
    + alias2(__default(require("../../../../js/helpers/stripSpecialChar.js")).call(alias1,(depth0 != null ? lookupProperty(depth0,"Tier") : depth0),{"name":"stripSpecialChar","hash":{},"data":data,"loc":{"start":{"line":3,"column":44},"end":{"line":3,"column":69}}}))
    + "\">\r\n        <p>"
    + alias2(alias3((depth0 != null ? lookupProperty(depth0,"DisplayTier") : depth0), depth0))
    + "</p>\r\n        <h4 class=\"pack-price\">"
    + alias2(alias3((depth0 != null ? lookupProperty(depth0,"DisplayPrice") : depth0), depth0))
    + "</h4>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depths[2] != null ? lookupProperty(depths[2],"IsTaxInclusive") : depths[2]),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":9},"end":{"line":8,"column":16}}})) != null ? stack1 : "")
    + "    </div>\r\n";
},"2":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <p>"
    + container.escapeExpression(container.lambda(((stack1 = (depths[2] != null ? lookupProperty(depths[2],"Labels") : depths[2])) != null ? lookupProperty(stack1,"TaxInclusivePriceText") : stack1), depth0))
    + "</p>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.hooks.blockHelperMissing.call(depth0,container.lambda((depth0 != null ? lookupProperty(depth0,"BundleConfiguration") : depth0), depth0),{"name":"BundleConfiguration","hash":{},"fn":container.program(0, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":11,"column":24}}})) != null ? stack1 : "");
},"useData":true,"useDepths":true});